module.exports = __webpack_public_path__ + "img/king-size-bed.392ee32a.svg";